import { render, staticRenderFns } from "./AddPricing.vue?vue&type=template&id=75ae2200&scoped=true&"
import script from "./AddPricing.vue?vue&type=script&lang=js&"
export * from "./AddPricing.vue?vue&type=script&lang=js&"
import style0 from "./AddPricing.vue?vue&type=style&index=0&id=75ae2200&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ae2200",
  null
  
)

export default component.exports